// autolayout/compatibilidad - S48.2a.
// Funcion pura: divide la compatibilidad tecnica (producto.descripcion)
// en lineas que no parten palabras. Usa separadores naturales.
//
// dividirCompatibilidadEnLineas(texto, anchoDisponible)
//   - texto: string con la compatibilidad completa.
//   - anchoDisponible: numero (mm o px). Heuristica: ~2.0 chars por mm
//     a fontSize "tipico" 7px. Para uso en autolayout, este numero
//     define el "presupuesto" de chars por linea.
//
// Algoritmo:
//   1) Si texto vacio -> [].
//   2) Cortar primero por separadores fuertes (" - ", " / ", ";", ".").
//     - Cada chunk se vuelve un candidato a linea.
//   3) Para chunks demasiado largos, partir por comas.
//   4) Para chunks aun demasiado largos, partir por palabras (espacios)
//     respetando el ancho disponible (sin cortar palabras).
//   5) Devolver array de strings (lineas).

const STRONG_SEPARATORS = [' - ', ' / ', '; ', '. '];

function _splitOn(text, sep) {
  const parts = text.split(sep);
  // Reanexar el separador (sin el espacio inicial) al final de cada parte
  // excepto la ultima, para preservar lectura.
  return parts;
}

function _splitByStrongs(text) {
  let chunks = [text];
  for (let i = 0; i < STRONG_SEPARATORS.length; i += 1) {
    const sep = STRONG_SEPARATORS[i];
    const next = [];
    for (let j = 0; j < chunks.length; j += 1) {
      const sub = _splitOn(chunks[j], sep);
      for (let k = 0; k < sub.length; k += 1) next.push(sub[k]);
    }
    chunks = next;
  }
  return chunks.map((s) => s.trim()).filter((s) => s.length > 0);
}

function _wrapWords(line, maxChars) {
  if (line.length <= maxChars) return [line];
  const words = line.split(/\s+/).filter(Boolean);
  const out = [];
  let cur = '';
  for (let i = 0; i < words.length; i += 1) {
    const w = words[i];
    if (cur.length === 0) {
      cur = w;
      continue;
    }
    if ((cur.length + 1 + w.length) <= maxChars) {
      cur = cur + ' ' + w;
    } else {
      out.push(cur);
      cur = w;
    }
  }
  if (cur.length > 0) out.push(cur);
  return out;
}

export function dividirCompatibilidadEnLineas(texto, anchoDisponible) {
  if (texto == null || texto === '') return [];
  const s = String(texto).trim();
  if (s.length === 0) return [];
  const ancho = Number(anchoDisponible) || 80;
  // Heuristica: ~1.8 chars por mm para fontSize chico tipico.
  const maxChars = Math.max(8, Math.round(ancho * 1.8));

  const strongs = _splitByStrongs(s);
  const out = [];
  for (let i = 0; i < strongs.length; i += 1) {
    const chunk = strongs[i];
    if (chunk.length <= maxChars) {
      out.push(chunk);
      continue;
    }
    // Partir por comas si el chunk excede.
    const byComma = chunk.split(',').map((x) => x.trim()).filter(Boolean);
    if (byComma.length > 1) {
      for (let j = 0; j < byComma.length; j += 1) {
        const sub = byComma[j];
        if (sub.length <= maxChars) {
          out.push(sub);
        } else {
          const wrapped = _wrapWords(sub, maxChars);
          for (let k = 0; k < wrapped.length; k += 1) out.push(wrapped[k]);
        }
      }
    } else {
      const wrapped = _wrapWords(chunk, maxChars);
      for (let k = 0; k < wrapped.length; k += 1) out.push(wrapped[k]);
    }
  }
  return out;
}
